export default {
    list: {
        title: "Aziende",
        subtitle: "Gestisci le aziende internazionali",
        newCompany: "Nuova Azienda",
        loading: "Caricamento aziende...",
        filters: {
            searchPlaceholder: "Cerca per nome, email, tax ID...",
            statusPlaceholder: "Filtra per stato",
            companyTypePlaceholder: "Filtra per tipo azienda",
            countryPlaceholder: "Filtra per paese",
            allTypes: "Tutti i tipi",
            allStatuses: "Tutti gli stati",
            allCountries: "Tutti i paesi",
            companyTypes: {
                sender: "Spedizioniere",
                receiver: "Destinatario",
                freightForwarder: "Spedizioniere Internazionale",
                carrier: "Vettore",
                customsBroker: "Doganiere",
                portAuthority: "Autorità Portuale",
                insuranceProvider: "Fornitore Assicurativo",
            },
        },
        table: {
            title: "Aziende",
            description: "Lista completa delle aziende",
            headers: {
                companyType: "Tipo Azienda",
                companyName: "Nome Azienda",
                legalName: "Nome Legale",
                country: "Paese",
                status: "Stato",
                createdAt: "Data Creazione",
                actions: "Azioni",
            },
            edit: "Modifica",
            manageTeam: "Team",
            menuConfig: "Config",
            noCompanies: {
                title: "Nessuna azienda trovata",
                message: "Prova a modificare i filtri di ricerca",
                emptyMessage: "Inizia creando la tua prima azienda",
                createFirst: "Crea la prima azienda",
            },
        },
        status: {
            active: "Attivo",
            suspended: "Sospeso",
            inactive: "Inattivo",
        },
        confirmDelete: "Sei sicuro di voler eliminare questa azienda?",
    },
    form: {
        edit: {
            title: "Modifica Azienda",
            subtitle: "Modifica i dettagli dell'azienda",
        },
        create: {
            title: "Nuova Azienda",
            subtitle: "Crea una nuova azienda",
        },
        loading: "Caricamento azienda...",
        back: "Indietro",
        sections: {
            general: "Informazioni Generali",
            address: "Indirizzo",
            contacts: "Contatti",
            notes: "Note Aggiuntive",
        },
        stepper: {
            step1: {
                title: "Informazioni Azienda",
                description: "Informazioni di base e dettagli legali dell'azienda",
            },
            step2: {
                title: "Gestione Team",
                description: "Aggiungi membri del team che possono accedere alla piattaforma",
                roles: {
                    operator: "Operatore",
                    companyAdmin: "Amministratore Azienda",
                },
                fields: {
                    email: "Email",
                    emailPlaceholder: "nome@azienda.com",
                    firstName: "Nome",
                    firstNamePlaceholder: "Inserisci nome",
                    lastName: "Cognome",
                    lastNamePlaceholder: "Inserisci cognome",
                    role: "Ruolo",
                    rolePlaceholder: "Seleziona ruolo",
                },
                addMember: "Aggiungi Membro del Team",
                addButton: "Aggiungi",
                remove: "Rimuovi",
                membersList: "Membri del Team",
                noMembers: "Nessun membro del team aggiunto. Puoi aggiungerli dopo la creazione dell'azienda.",
                duplicateEmail: "Questa email è già stata aggiunta al team",
            },
        },
        fields: {
            companyType: "Tipo Azienda",
            companyTypePlaceholder: "Seleziona il tipo di azienda",
            companyTypes: {
                sender: "Spedizioniere",
                receiver: "Destinatario",
                freightForwarder: "Spedizioniere Internazionale",
                carrier: "Vettore",
                customsBroker: "Doganiere",
                portAuthority: "Autorità Portuale",
                insuranceProvider: "Fornitore Assicurativo",
            },
            companyName: "Nome Azienda",
            companyNamePlaceholder: "Inserisci il nome dell'azienda",
            legalName: "Nome Legale",
            legalNamePlaceholder: "Inserisci il nome legale",
            entityType: "Tipo Entità",
            entityTypePlaceholder: "Seleziona il tipo di entità",
            taxId: "Partita IVA / Tax ID",
            taxIdPlaceholder: "Inserisci la partita IVA o Tax ID",
            status: "Stato",
            statusPlaceholder: "Seleziona lo stato",
            street: "Via",
            streetPlaceholder: "Inserisci l'indirizzo completo",
            city: "Città",
            cityPlaceholder: "Inserisci la città",
            state: "Stato/Provincia",
            statePlaceholder: "Inserisci stato o provincia",
            postalCode: "CAP",
            postalCodePlaceholder: "Inserisci il codice postale",
            country: "Paese",
            countryPlaceholder: "Seleziona il paese",
            email: "Email",
            emailPlaceholder: "nome@azienda.com",
            phone: "Telefono",
            phonePlaceholder: "+39 123 456 7890",
            notes: "Note",
            notesPlaceholder: "Inserisci note aggiuntive sull'azienda...",
        },
        actions: {
            cancel: "Annulla",
            save: "Salva Modifiche",
            create: "Crea Azienda",
            next: "Avanti",
            back: "Indietro",
            previous: "Precedente",
            menuConfig: "Configurazione Menu",
        },
        saving: "Salvataggio company...",
        creating: "Creazione company...",
    },
    team: {
        title: "Team di {{companyName}}",
        subtitle: "Gestisci i membri del team e gli inviti pendenti",
        loading: "Caricamento team...",
        errorLoading: "Errore nel caricamento dei dati del team",
        companyNotFound: "Azienda non trovata",
        backToCompanies: "Torna alle Aziende",
        addMember: "Aggiungi Membro",
        activeMembers: "Membri Attivi",
        activeMembersDescription: "Utenti attivi che hanno accesso alla piattaforma",
        pendingInvitations: "Inviti Pendenti",
        pendingInvitationsDescription: "Inviti email in attesa di accettazione",
        noActiveMembers: "Nessun membro attivo",
        roles: {
            superAdmin: "Super Admin",
            companyAdmin: "Amministratore Azienda",
            operator: "Operatore",
            viewer: "Visualizzatore",
        },
        status: {
            active: "Attivo",
            inactive: "Inattivo",
            pending: "In Attesa",
            expired: "Scaduto",
        },
        table: {
            headers: {
                name: "Nome",
                email: "Email",
                role: "Ruolo",
                status: "Stato",
                joinedAt: "Unito il",
                invitedAt: "Invitato il",
                expiresAt: "Scade il",
            },
        },
        form: {
            email: "Email",
            emailPlaceholder: "membro@esempio.com",
            firstName: "Nome",
            firstNamePlaceholder: "Mario",
            lastName: "Cognome",
            lastNamePlaceholder: "Rossi",
            role: "Ruolo",
            activationMethod: "Metodo di attivazione",
            activationMethods: {
                emailInvitation: "Invio invito via email",
                directActivation: "Attivazione diretta da admin",
            },
            password: "Password",
            passwordPlaceholder: "Inserisci password (min 8 caratteri)",
            passwordConfirm: "Conferma password",
            passwordConfirmPlaceholder: "Conferma la password",
            addButton: "Aggiungi Membro",
            addingMember: "Aggiunta membro del team...",
        },
        error: {
            emailRequired: "L'email è obbligatoria",
            passwordRequired: "Password e conferma password sono obbligatorie",
            passwordMinLength: "La password deve contenere almeno 8 caratteri",
            passwordMismatch: "Password e conferma password non coincidono",
            addingMember: "Errore nell'aggiunta del membro del team",
            updatingMember: "Errore nell'aggiornamento del membro del team",
            removingMember: "Errore nella rimozione del membro del team",
            resendingInvitation: "Errore nel reinvio dell'invito",
        },
        success: {
            memberAdded: "Membro del team aggiunto con successo",
            memberInvitationSent: "Invito email inviato con successo",
            memberCreatedDirect: "Utente creato e attivato con successo",
            memberUpdated: "Membro del team aggiornato con successo",
            memberRemoved: "Membro del team rimosso con successo",
            invitationResent: "Email di invito rinviata con successo",
        },
        actions: {
            edit: "Modifica",
            remove: "Rimuovi",
            resend: "Rimanda",
        },
        editMember: {
            title: "Modifica Membro del Team",
            name: "Nome",
            email: "Email",
            isActive: "Attivo",
            saveButton: "Salva Modifiche",
        },
        removeMember: {
            title: "Rimuovi Membro del Team",
            confirmation: "Sei sicuro di voler rimuovere {{name}} ({{email}}) da questa azienda?",
            sendNotificationEmail: "Invia email di notifica all'utente",
            confirmButton: "Rimuovi Membro",
        },
        resetData: {
            menuItem: "Reset Dati",
            title: "Reset Dati Utente",
            warning: "Questo eliminerà permanentemente tutti i dati operativi dell'azienda di questo utente. Utente e azienda saranno preservati.",
            mode: "Modalità di Esecuzione",
            dryRun: "Simulazione (solo anteprima)",
            force: "Forza (elimina dati)",
            deleteEmails: "Cancella anche le email",
            deleteEmailsHint: "Di default le email vengono preservate e resettate per il riprocessamento. Attiva solo se vuoi rifare il sync dal provider.",
            run: "Esegui",
            running: "In esecuzione...",
            completed: "Completato",
            error: "Si è verificato un errore",
            close: "Chiudi",
        },
    },
    menuConfig: {
        title: "Configurazione Menu",
        subtitle: "Configura le voci di menu per {{companyName}}",
        back: "Torna alla Company",
        backToCompanies: "Torna alle Aziende",
        companyNotFound: "Azienda non trovata",
        loading: "Caricamento configurazione menu...",
        override: {
            title: "Override Configurazione Menu",
            descriptionHasOverride: "Questa azienda ha una configurazione menu personalizzata. Le modifiche qui sovrascriveranno le impostazioni globali.",
            descriptionNoOverride:
                "Questa azienda utilizza la configurazione menu globale. Abilita l'override per personalizzare le voci di menu solo per questa azienda.",
            deleteButton: "Elimina Override",
            deleteConfirm: "Sei sicuro di voler eliminare l'override del menu? L'azienda utilizzerà la configurazione globale.",
            deleteSuccess: "Override del menu eliminato con successo",
            deleteError: "Errore nell'eliminazione dell'override del menu",
            saveButton: "Salva Override",
            saving: "Salvataggio...",
            saveSuccess: "Override del menu salvato con successo",
            saveError: "Errore nel salvataggio dell'override del menu",
            resetButton: "Reset",
            loading: "Caricamento configurazione...",
            noItems: "Nessuna voce di menu disponibile per questo tipo di azienda",
            alwaysEnabled: "Sempre Abilitato",
            key: "Chiave",
            badge: "Override",
        },
    },
};
